import { BasePage } from "src/app/base";
import { GenericServerResponse, SaleOrder } from "@tendercuts/models";
import { InvoicePage } from "../../home/invoice/invoice.page";
import { ModalController } from "@ionic/angular";
import {
  Component,
  Injector,
  Input,
  Output,
  EventEmitter,
} from "@angular/core";
import {
  QuoteSerializerService,
  MarkAsCompleteService,
} from "@tendercuts/providers";

@Component({
  selector: "app-order-display",
  templateUrl: "./order-display.component.html",
  styleUrls: ["./order-display.component.scss"],
})
export class OrderDisplayComponent extends BasePage {
  @Input() order: SaleOrder;
  /**display only in pickup order page */
  @Input() isOnlineOrder: boolean;
  /**To refresh the parent page and update child page*/
  @Output() refreshParentEmiter = new EventEmitter<any>();

  constructor(
    public modalCtrl: ModalController,
    public quoteSerializeService: QuoteSerializerService,
    public markAsCompleteService: MarkAsCompleteService,
    public injector: Injector
  ) {
    super(injector);
  }
  /**
   * Print the invoice in order history mode so set the attribute true
   */
  async printInvoice() {
    const posQuote = this.quoteSerializeService.posQuoteSerializer(this.order);

    const modal = await this.modalCtrl.create({
      component: InvoicePage,
      componentProps: { posQuote, isHistoryBill: true },
    });
    modal.present();
  }

  /**
   * ask store for conformation to complete order
   * if yes it will make order as complete state and
   * refresh the page
   */
  async markAsComplete() {
    let buttons = [
      {
        text: "Cancel",
        role: "cancel",
        cssClass: "secondary",
        handler: () => {},
      },
      {
        text: "Yes, continue",
        handler: () => {
          this.proccedToComplete();
        },
      },
    ];
    await this.showConfirm(
      "Mark As Complete",
      `Are you sure you want to complete this order ?`,
      "",
      [],
      buttons,
      false
    );
  }

  /**to complete the order and show the response */
  async proccedToComplete() {
    this.presentLoader("Complete order");
    let param = this.markAsCompleteService.getParams(this.order.incrementId);
    let response = await this.markAsCompleteService
      .getData(param)
      .toPromise()
      .catch((err) => this.somethingWentWrong());
    this.dismissLoader();
    this.showAlert(response[0].message, "");
    this.refreshParentEmiter.emit();
  }
}
